export default {
  columnWidths: {
    metricsLabels: 35,
    norm: 10,
    metrics: 15
  },
  columnFormats: {
    norm: {
      fill: '#eeeeee'
    }
  },
  defaultAlignment: 'center',
  defaultRowHeight: 15,
  defaultFontSize: 10,
  styles: {
    h1: {
      type: 'header',
      height: 25,
      format: {
        fill: '#eeeeee',
        color: '#002C59',
        font: {
          size: 12,
          bold: true
        }
      }
    },
    d1: {
      type: 'metric',
      height: 15,
      offset: '        '
    }
  },

  sheetHeaders: [
    {
      field: 'ad_code',
      rowHeight: 25,
      metricsLabel: 'Ad Code',
      alignment: 'center',
      font: {
        bold: true,
        size: 12
      }
    },
    {
      field: 'title',
      metricsLabel: 'Title',
      alignment: 'center'
    },
    {
      field: 'brand',
      metricsLabel: 'Brand',
      alignment: 'center'
    },
    {
      field: 'thumbnail',
      rowHeight: 50,
      normLabel: 'NORM',
      alignment: 'center',
      font: {
        bold: true,
        size: 12
      }
    },
    {
      field: 'product_campaign',
      metricsLabel: 'Product Campaign',
      font: {
          italic: true
      }
    },
    {
      field: 'length',
      metricsLabel: 'Ad Length'
    },
    {
      field: 'first_air_date',
      metricsLabel: 'First Air Date'
    },
    {
      field: 'ad_type',
      metricsLabel: 'Ad Type'
    }
  ]
}
